// @flow

import React from 'react';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'components/Col/Col';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import type { L10n, ParticipantPhotos } from 'type/type';
import isEmpty from 'lodash/fp/isEmpty';
import map from 'lodash/fp/map';
import compose from 'lodash/fp/compose';
import prop from 'lodash/fp/prop';

import MediaLinkCell from './MediaLinkCell/MediaLinkCell';
import './MediaLinkBoard.scss';

type Props = {
  l10n: L10n,
  participantCustomFields: {
    photoURL: ParticipantPhotos,
    certificateURL: string,
    videoURL: string
  }
}

const MediaLinkBoard = ({ participantCustomFields, l10n: { formatMessage }, toggleGallery }: Props) => {
  const { videoURL, photoURL, certificateURL } = participantCustomFields || {};
  const largeUrls = compose(map('largeUrl'), prop('content'))(photoURL);
  const mediaNotes = {
    videoNote: videoURL ? formatMessage('page.participant.media.videos') : formatMessage('page.participant.media.no.videos'),
    photoNote: !isEmpty(largeUrls) ? formatMessage('page.participant.media.photos') : formatMessage('page.participant.media.no.photos'),
    certificateNote: certificateURL ? formatMessage('page.participant.media.certificate') : formatMessage('page.participant.media.no.certificates'),
  };

  const mediaLinkData = [
    { type: 'VIDEO', url: videoURL, note: mediaNotes.videoNote },
    {
      type: 'PHOTO', url: largeUrls, note: mediaNotes.photoNote, toggleGallery,
    },
    { type: 'CERTIFICATE', url: certificateURL, note: mediaNotes.certificateNote },
  ];

  return (
    <div className="media-link-board">
      <Row gutter={0} fluid>
        { mediaLinkData.map((mediaLink) => {
          return (
            <Col span={12} xl={4} className="media-link-board__cell" key={mediaLink.type}>
              <MediaLinkCell {...mediaLink} />
            </Col>
          );
        }) }
      </Row>
    </div>
  );
};

export default injectL10n()(MediaLinkBoard);
